import { ReduceStore } from 'flux/utils';
import { Record, Map, List } from 'immutable';
import moment from 'moment';

import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

export class LogEntry extends Record({ level: null, timestamp: null, message: '', json: null }) {

}

class LogStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, { actionType, ...action }) {
    switch (actionType) {
      case Constants.RECEIVE_JOB_LOGS: {
        let logs = new List();
        if (typeof action.stdout === 'string') {
          logs = this._parseLogs(action.stdout);
        }
        return state.set(action.job, logs);
      }

      default:
        return state;
    }
  }

  getLogs(jobId) {
    return this.getState().get(jobId, new List());
  }

  _parseLogs(logs) {
    return new List(logs.split('\n').map((l) => {
      try {
        const rawJson = JSON.parse(l);
        return new LogEntry({
          level: rawJson.level,
          timestamp: moment(rawJson['@timestamp']),
          message: rawJson.message,
          json: rawJson,
        });
      } catch (e) {
        // console.warn('Malformed Log Entry', l);
        return null;
      }
    }).filter((e) => e !== null));
  }

  _setLogs(jobId, value) {
    this._logs = this._logs.set(jobId, value);
  }
}

const instance = new LogStore(AppDispatcher);
export default instance;
